import { render, staticRenderFns } from "./op-head-logistics-modal.vue?vue&type=template&id=3644d602&scoped=true&"
import script from "./op-head-logistics-modal.vue?vue&type=script&lang=js&"
export * from "./op-head-logistics-modal.vue?vue&type=script&lang=js&"
import style0 from "./op-head-logistics-modal.vue?vue&type=style&index=0&id=3644d602&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3644d602",
  null
  
)

export default component.exports